<template>
  <div>
    <ContentHeader :budget-nav="true" :show-back="false" />

    <div class="content-container">
      <BudgetGrid budget-type="pocm" />
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import BudgetGrid from './components/budget-grid'
export default {
  name: 'budget-pocm-data',
  components: {
    ContentHeader,
    BudgetGrid
  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>
